import React, { useEffect, useState } from "react";
import "../../styles/app.css"
import EditintroModal from "../../Models/IntroEditModel/IntroEdit";
import EditServicesModal from "../../Models/ServicesEditModel/EditServices";
import AddAlbum from "../../Models/AddAlbumsModel/addAlbums";
import { useNavigate } from "react-router-dom";
import AddPhotoUpload from "../../Models/AddPhotoModel/addPhoto";
import BusinessCardModel from "../../Models/BuisnessCardsModel/BuisnessCardsModel";
import VideoUpload from "../../Models/AddVideoModel/addVideo";
import { MediaGet } from "../../apis/api/GalleryApis";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
const LeftSidebar = ({ profileData }) => {
  const [Photodata, setPhotodata] = useState([]);
  const [Videodata, setVideodata] = useState([]);
  const [branches, setBranches] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const access = JSON.parse(Cookies.get("access"));

  useEffect(() => {
    console.log("Branches: ", profileData?.data?.branches)
    if(profileData?.data){
      setBranches(profileData?.data?.branches)
      if(profileData?.data?.branches && profileData?.data?.branches.length > 0)
        setSelectedBranch(profileData?.data?.branches[0]);
    }
  }, [profileData])



  const { album } = useSelector((state) => state.GallerySlice);

  const company_data = profileData?.data?.company_data;
  console.log(company_data, "company_data");
  const member_data = profileData?.data?.member_data;
  const service_data = profileData?.data?.services;
  const Certificate_data = profileData?.data?.Certificates;
  

  const company_id = Cookies.get("company_id");
  const userId = Cookies.get("userID");
  const dispatch = useDispatch();
  const [showIntroModal, setShowIntroModal] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showBuisnessModal, setShowBuisnessModal] = useState(false);
  const [addAlbum, setAddAlbum] = useState(false);
  const [addPhotoUpload, setAddPhotoUpload] = useState(false);
  const [videoUpload, setaddVideo] = useState(false);
  const [businessCardData, setShowBuisnesscard] = useState();
  const location = useLocation();
  const navigate = useNavigate();


  const NavigateAlbum = () => {
    navigate("/albumCard", { state: { from: location.pathname } });
  };

  const navigateCertificate = (company_id) => {
    navigate("/certificates", { state: { company_id, from: location.pathname } });
  };

  const Navigatephoto = () => {
    navigate("/photos-gallery", { state: { from: location.pathname } });
  };
  const Navigatevideo = () => {
    navigate("/videos-gallery", { state: { from: location.pathname } });
  };

  const navigateMember = () => {
    navigate("/member", {
      state: {
        company_id: company_id,
        userId: userId,
        from: location.pathname
      },
    });
  };

  useEffect(() => {
    dispatch(MediaGet({ company_id: company_id }));
  }, []);

  const { media } = useSelector((state) => state.GallerySlice);

  useEffect(() => {
    if (media?.result && media?.result?.length > 0) {
      const photoItems = media?.result.filter(
        (item) => item.extension_type == "image"
      );
      const videoItems = media?.result.filter(
        (item) => item.extension_type == "video"
      );

      setPhotodata(photoItems);
      setVideodata(videoItems);
    } else {
      setPhotodata([]);
      setVideodata([]);
    }
  }, [media]);

  function formatDate(timestamp) {
    if (!timestamp) return " ";
    const date = new Date(Number(timestamp) * 1000);

    if (isNaN(date.getTime())) return "Invalid Date";

    const day = date.getDate();
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  function filterMemeberDataforCard(id) {
    const filterddata = member_data.filter((member) => {
      return member.id == id;
    });
    setShowBuisnesscard(filterddata);
    setShowBuisnessModal(true);
  }
  const handleDownload = async (url, filename) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename || "certificate";
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);

    }
  };

  const hasAlbums = album?.result?.[0]?.data?.length > 0;
  const hasPhotos = Array.isArray(Photodata) && Photodata.length > 0 && !!Photodata[0]?.file_url;
  const hasVideos = Array.isArray(Videodata) && Videodata.length > 0 && !!Videodata[0]?.file_url;


  return (
    <>
      <EditintroModal
        show={showIntroModal}
        handleClose={() => setShowIntroModal(false)}
        data={company_data}
      />
      <BusinessCardModel
        show={showBuisnessModal}
        handleClose={() => setShowBuisnessModal(false)}
        data={businessCardData}
      />
      <EditServicesModal
        show={showServiceModal}
        handleClose={() => setShowServiceModal(false)}
        servicesData={service_data}
      />

      <AddAlbum show={addAlbum} handleClose={() => setAddAlbum(false)} />

      <AddPhotoUpload
        show={addPhotoUpload}
        handleClose={() => setAddPhotoUpload(false)}
      />

      <VideoUpload show={videoUpload} handleClose={() => setaddVideo(false)} />

      <div className="col-md-6 col-12 fixed-column">
        <div className="form-row col-12  col-md-12 col-lg-12 col-xl-12 col-xxl-12 z-14 child">
          <div className="intro w-100 bg-white">
            <section class="container container1 ">
              <div class="row align-items-center">
                <div class="container my-2 ">
                  <div class="col-md-12 d-flex align-items-center justify-content-between mb-4">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-globe me-1 "></i>
                      <h4 class="fw-bold text-theme mb-0">Intro</h4>
                    </div>

                    <button
                      class="btn btn-outline-secondary bg-theme-color btn-sm"
                      onClick={() => setShowIntroModal(true)}
                    >
                      <i class="bx bx-edit"></i>
                      Edit
                    </button>
                  </div>

                  <div class="row justify-content-center">
                    <div>
                      <p className="lead text-muted fs-6 text-start">
                        {company_data?.bio ? (
                          /<[a-z][\s\S]*>/i.test(company_data.bio) ? (
                            <span>
                              {company_data.bio.replace(/<[^>]*>?/gm, "")}
                            </span>
                          ) : (
                            <span>{company_data.bio}</span>
                          )
                        ) : (
                          <span>company bio...</span>
                        )}
                      </p>

                      <hr />
                      <div class="d-flex justify-content-start">
                        <ul class="list-unstyled text-start f">
                          <li className="mb-2 fs-6">
                            Membership Start Date:{" "}
                            {formatDate(company_data?.membership_start)}
                          </li>
                          <li className="mb-2 fs-6">
                            Membership End Date:{" "}
                            {formatDate(company_data?.membership_expire)}
                          </li>
                          <li className="mb-2 fs-6">
                            Foundation Date:{" "}
                            {formatDate(company_data?.foundation_date)}
                          </li>

                          <li className="mb-2 fs-6">
                            Pay Password: {company_data?.pay_password}
                          </li>
                          <li className="mb-2 fs-6">
                            Referral Code: {company_data?.referral_code}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          {(access.gallery_access && access.gallery_access === "1") && 
            <div className="container mb-3 container1 w-100 bg-white p-4 mt-4">
              <div className="mt-3">
                <h4 className="text-theme mt-3 mb-4 ms-1">Media</h4>
              </div>

              {/* Actions row (avoid nested .container and conflicting justify classes) */}
              <div className="row g-2 d-flex align-items-center justify-content-evenly flex-wrap">
                <div className="col-12 col-sm-auto">
                  <button
                    onClick={() => setAddAlbum(true)}
                    className="btn btn-outline-secondary bg-theme-color btn-sm w-100"
                  >
                    <i className="bx bx-plus me-2 ms-1"></i>
                    Add Album
                  </button>
                </div>

                <div className="col-12 col-sm-auto">
                  <button
                    onClick={() => setAddPhotoUpload(true)}
                    className="btn btn-outline-secondary bg-theme-color btn-sm w-100"
                  >
                    <i className="bx bx-plus me-2 ms-1"></i>
                    Add Photo
                  </button>
                </div>

                <div className="col-12 col-sm-auto">
                  <button
                    onClick={() => setaddVideo(true)}
                    className="btn btn-outline-secondary bg-theme-color btn-sm w-100"
                  >
                    <i className="bx bx-plus me-2 ms-1"></i>
                    Add Video
                  </button>
                </div>
              </div>

              {/* Cards grid */}
              <div className="mt-4">
                <div className="row g-4">
                  {hasAlbums || hasPhotos || hasVideos ? (
                    <>
                      {/* Album Card */}
                      {hasAlbums && (
                        <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                          <div
                            className="card album-card shadow border-0 rounded-3 h-100"
                            onClick={NavigateAlbum}
                            role="button"
                          >
                            <div className="card-body text-center d-flex flex-column align-items-center">
                              <h5 className="card-title fw-bold mb-4">Albums</h5>
                              <div className="w-100">
                                <div className="row row-cols-2 g-2">
                                  {album.result[0].data
                                    .slice(0, 4)
                                    .map((item, index) => (
                                      <div className="col" key={index}>
                                        {item.extension_type === "image" && (
                                          <img
                                            src={item.file_url}
                                            className="img-fluid rounded-2"
                                            alt={`Album ${index + 1}`}
                                            style={{
                                              height: 100,
                                              width: "100%",
                                              objectFit: "cover",
                                            }}
                                          />
                                        )}
                                        {item.extension_type === "video" && (
                                          <video
                                            src={item.file_url}
                                            className="img-fluid rounded-2"
                                            style={{
                                              height: 100,
                                              width: "100%",
                                              objectFit: "cover",
                                            }}
                                            muted
                                          />
                                        )}
                                        {item.extension_type === "audio" && (
                                          <div
                                            className="bg-light rounded-2 p-2 d-flex justify-content-center align-items-center"
                                            style={{ height: 100 }}
                                          >
                                            <audio controls className="w-100">
                                              <source
                                                src={item.file_url}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support the
                                              audio element.
                                            </audio>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Photo Card */}
                      {hasPhotos && (
                        <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                          <div
                            className="card album-card shadow border-0 rounded-3 h-100"
                            onClick={Navigatephoto}
                            role="button"
                          >
                            <div className="card-body text-center d-flex flex-column align-items-center">
                              <h5 className="card-title fw-bold">Photos</h5>
                              <img
                                src={Photodata[0].file_url}
                                className="rounded-3 mt-3 album-img img-fluid"
                                alt="Photo Album"
                                style={{
                                  maxHeight: 220,
                                  width: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Video Card */}
                      {hasVideos && (
                        <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                          <div
                            className="card album-card shadow border-0 rounded-3 h-100"
                            onClick={Navigatevideo}
                            role="button"
                          >
                            <div className="card-body text-center d-flex flex-column align-items-center">
                              <h5 className="card-title fw-bold">Videos</h5>
                              <video
                                src={Videodata[0].file_url}
                                className="rounded-3 mt-3 album-img img-fluid"
                                style={{
                                  maxHeight: 220,
                                  width: "100%",
                                  objectFit: "cover",
                                }}
                                muted
                                playsInline
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <p className="fw-bold text-center m-0 py-3">
                      No media available.
                    </p>
                  )}
                </div>
              </div>
            </div>
          }

          {/* Office and Branches Section */}
          {/* <div className="container mb-3 w-100 bg-white p-4 shadow rounded">
            <div className="col-md-12 d-flex align-items-center justify-content-between mb-4">
              
              <div className="d-flex align-items-center">
                <i className="fas fa-building me-2 text-theme"></i>
                <h5 className="fw-bold text-theme mb-0">Office and Branches</h5>
              </div>

              
              <div className="d-flex align-items-center gap-2">
                <span className="badge bg-theme-color text-white fs-6 px-3 py-2 rounded-pill">
                  {branches ? branches.length : 0} Branches
                </span>
                <button
                  className="btn btn-outline-secondary btn-sm rounded-3 d-flex align-items-center"
                  onClick={() =>
                    navigate("/branches", { state: { from: location.pathname } })
                  }
                >
                  <i class="bx bx-edit"></i>Edit
                </button>
              </div>
            </div>


            {(branches && branches.length > 0) ? (
              <>
                
                <div className="row mb-3">
                  {branches.slice(0, 3).map((branch) => (
                    <div key={branch.id} className="col-md-4 col-sm-6 col-12 mb-3">
                      <div
                        className={`ob-card card border-0 h-100 shadow-sm text-center ${selectedBranch?.id === branch.id ? "ob-card-selected" : ""
                          }`}
                        onClick={() => setSelectedBranch(branch)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="card-body d-flex flex-column align-items-center p-3">
                          <div className="ob-icon-circle mb-2">
                            <i className="bx bx-buildings fs-3"></i>
                          </div>
                          <h6 className="fw-bold mb-1">{branch.main_branch === 1 ? `Head Office` : `${branch.city} Branch`}</h6>
                          <p className="text-muted small mb-0">{branch.city}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>


                
                {(branches.length > 3) && (
                  <div className="text-center mb-4">
                    <button
                      className="btn btn-outline-secondary btn-sm rounded-pill px-4"
                      onClick={() =>
                        navigate("/branches", { state: { from: location.pathname } })
                      }
                    >
                      View All <i className="bx bx-right-arrow-alt"></i>
                    </button>
                  </div>
                )}

                
                <div className="card border-0 shadow-sm rounded p-4 bg-light">
                  <h6 className="fw-bold mb-3 text-primary">
                    <i className="bx bx-map-pin me-1"></i> Branch Details
                  </h6>
                  {selectedBranch ? (
                    <ul className="list-unstyled small mb-0">
                      <li className="mb-2">
                        <i className="bx bx-home me-2 text-theme"></i>
                        <strong>Address:</strong>{" "}
                        {`${selectedBranch.city}, ${selectedBranch.country}`}
                      </li>
                      <li className="mb-2">
                        <i className="bx bx-phone me-2 text-theme"></i>
                        <strong>Phone:</strong> {selectedBranch.contact}
                      </li>
                      <li className="mb-2">
                        <i className="bx bx-envelope me-2 text-theme"></i>
                        <strong>Email:</strong> {selectedBranch.email}
                      </li>
                    </ul>
                  ) : (
                    <p className="text-muted">Select a branch to view details.</p>
                  )}
                </div>
              </>
            ) : (
              <p>No branch data available.</p>
            )}
          </div> */}

          {member_data ? (
            <div className="container mb-3 w-100 bg-white p-4 shadow rounded">
              <div class="col-md-12 d-flex align-items-center justify-content-between mb-4">
                <div class="d-flex align-items-center">
                  <i class="fas fa-globe me-1 "></i>
                  <h4 class="fw-bold text-theme mb-0">Contact</h4>
                </div>

                <button
                  class="btn btn-outline-secondary bg-theme-color btn-sm"
                  onClick={() => {
                    navigateMember();
                  }}
                >
                  <i class="bx bx-edit"></i>
                  Edit
                </button>
              </div>
              <div className="row">
                <div className="row">
                  {member_data?.length > 0 &&
                    member_data.map((member, index) => (
                      <div
                        key={index}
                        className="col-12 col-sm-12 col-md-6 col-lg-6"
                      >
                        <div className="our-team rounded-1">
                          <div className="picture">
                            <img
                              className="img-fluid w-100 h-100"
                              src={
                                member?.member_logo ||`${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`
                              }
                              alt="team member"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                  "/gray-avatar-icon-vector-illustration_276184-163.avif";
                              }}
                            />
                          </div>

                          <div className="team-content">
                            {(member?.salutation ||
                              member?.first_name ||
                              member?.middle_name ||
                              member?.last_name) && (
                              <span className="name">
                                {`${member.salutation || ""} ${
                                  member.first_name || ""
                                } ${member.middle_name || ""} ${
                                  member.last_name || ""
                                }`.trim()}
                              </span>
                            )}

                            {member?.job_title && (
                              <h6 className="title">{member.job_title}</h6>
                            )}
                          </div>

                          {member?.department && (
                            <span>Department: {member.department}</span>
                          )}

                          {member?.contact && (
                            <p className="">
                              +{member?.country_code}
                              {member?.contact}
                            </p>
                          )}

                          {member?.email && <p className="">{member.email}</p>}
                          <div className="pb-3">
                            <button
                              class="btn btn-outline-secondary btn-sm"
                              onClick={() =>
                                filterMemeberDataforCard(member.id)
                              }
                            >
                              <i class="bx bx-show"></i> View Business Card
                            </button>
                          </div>

                          <ul className="social">
                            {/* WhatsApp */}
                            {member?.contact && (
                              <li>
                                <a
                                  href={`https://wa.me/${String(
                                    member.country_code
                                  ).replace(/\D/g, "")}${String(
                                    member.contact
                                  ).replace(/\D/g, "")}`}
                                  className="bx bxl-whatsapp"
                                  aria-hidden="true"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                ></a>
                              </li>
                            )}

                            {/* Phone */}
                            {/* {member?.contact && (
                              <li>
                                <a
                                  href={`tel:+${member?.country_code}${member?.contact}`}
                                  className="bx bx-phone"
                                  aria-hidden="true"
                                ></a>
                              </li>
                            )} */}

                            {/* Email */}
                            {member?.email && (
                              <li>
                                <a
                                  href={`mailto:${member?.email}`}
                                  className="bx bx-envelope"
                                  aria-hidden="true"
                                ></a>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    ))}

                  {/* Button rendered only if there is member data */}
                </div>
              </div>
            </div>
          ) : (
            <p> No Contact available. </p>
          )}

          <div className="container mb-3 w-100 bg-white p-4 shadow rounded">
            <div className="col-md-12 d-flex align-items-center justify-content-between mb-4">
              <div className="d-flex align-items-center">
                <i className="fas fa-file-alt me-1"></i>
                <h4 className="fw-bold text-theme mb-0">Certificates</h4>
              </div>
              <button
                class="btn btn-outline-secondary bg-theme-color btn-sm"
                onClick={() => navigateCertificate(company_id)}
              >
                <i class="bx bx-edit"></i>
                Edit
              </button>
            </div>

            {Certificate_data && Certificate_data.length > 0 ? (
              <div className="row">
                {Certificate_data.slice(0, 3).map((cert) => {
                  const cleanUrl = cert.file_url.replace("thumb/", "");

                  return (
                    <div
                      key={cert.id}
                      className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4 border-rounded"
                    >
                      <div
                        className="card h-100 shadow-sm border-0"
                        style={{
                          transition: "transform 0.2s, box-shadow 0.2s",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.transform = "translateY(-5px)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.transform = "translateY(0px)")
                        }
                      >
                        <div
                          className="card-img-top text-center bg-light p-3"
                          style={{ height: "180px" }}
                        >
                          {cert.file_extension === "pdf" ? (
                            <i className="bx bxs-file-pdf fs-1 text-danger"></i>
                          ) : cert.file_extension === "doc" ||
                            cert.file_extension === "docx" ? (
                            <i className="bx bxs-file-doc fs-1 text-primary"></i>
                          ) : (
                            <img
                              src={cert.file_url}
                              alt={cert.file_name}
                              className="img-fluid rounded"
                              style={{
                                maxHeight: "140px",
                                objectFit: "cover",
                              }}
                            />
                          )}
                        </div>

                        <div className="card-body">
                          <h6
                            className="card-title text-truncate"
                            title={cert.title}
                          >
                            {cert.title}
                          </h6>
                          <p className="text-muted small mb-2">
                            Uploaded:{" "}
                            {new Date(
                              cert.created_at * 1000
                            ).toLocaleDateString()}
                          </p>

                          <div className="d-flex justify-content-between">
                            {/* View Button */}
                            <a
                              href={cleanUrl}
                              className="btn btn-sm btn-outline-warning me-2"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="bx bx-show"></i>
                            </a>

                            {/* Download Button */}
                            <button
                              className="btn btn-sm btn-outline-primary me-2"
                              onClick={() =>
                                handleDownload(cleanUrl, cert.title)
                              }
                              title="Download"
                            >
                              <i className="bx bx-download"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p>No documents available.</p>
            )}

            {Certificate_data?.length > 3 && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => navigateCertificate(company_id)}
                >
                  View More <i className="bx bx-right-arrow-alt"></i>
                </button>
              </div>
            )}
          </div>

          <div className="container mb-3 w-100 bg-white p-4 shadow rounded">
            <div class="col-md-12 d-flex align-items-center justify-content-between mb-4">
              <div class="d-flex align-items-center">
                <i class="fas fa-globe me-1 "></i>
                <h4 class="fw-bold text-theme mb-0">Services</h4>
              </div>

              <button
                class="btn btn-outline-secondary bg-theme-color btn-sm"
                onClick={() => setShowServiceModal(true)}
              >
                <i class="bx bx-edit"></i>
                Edit
              </button>
            </div>
            {service_data && service_data.length > 0 ? (
              <div className="row">
                {service_data.map((service, index) => (
                  <div key={index} className="col-md-6 col-lg-6 col-sm-6 mb-3">
                    <div className="d-flex align-items-center p-3 border rounded shadow-sm bg-light">
                      {service.icon_url && (
                        <img
                          src={service.icon_url}
                          alt="Service Icon"
                          style={{ height: "33px" }}
                          className="me-2"
                        />
                      )}
                      <span className="fw-bold">{service.service_name}</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p> No services Available. </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default LeftSidebar;
